export function getValue<K extends string | number | symbol, V>(value: K, obj: Record<K, V>): V {
  return obj[value];
}
